// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

const homeInsuranceData = {
  faqs: [
    {
      icon: "hdr_strong",
      question: "How do I get covered for maternity?",
      answer:
        "All medical insurance companies in Kenya cover maternity subject to a waiting period of 10-12 months. So, it is not possible to get a maternity insurance a pregrancy has started. Some health insurance plans in Kenya cover maternity as part of the InPatient limits while most of the plans offer maternity cover as an optional benefit at an additional cost.",
    },
    {
      icon: "hdr_weak",
      question: "Can I cover my child separately?",
      answer:
        "It is possible to cover juniors less than 18 years old on a medical insurance plan without requiring an adult to be insured on the same plan. However, only plans for inpatient medical insurance are available for juniors.",
    },
    {
      icon: "hdr_strong",
      question: "What about optical and dental covers?",
      answer:
        "Optical and Dental are mainly offered as optional benefits on most of the health insurance options. They offer valuable insurance against common eye and tooth conditions that may cause unplanned physical and financial stress. These two options may only be taken with an inpatient and outpatient plan.",
    },
    {
      icon: "hdr_weak",
      question: "Will this insurance work with my NHIF?",
      answer:
        "Yes, health insurance will work with the NHIF cover. Medical bills incurred in hospital especially for inpatient visits may be paid net of NHIF limits. This means your medical insurance limits will take you further courtesy of the NHIF benefits.",
    },
    {
      icon: "hdr_strong",
      question: "Can I take an outpatient plan only?",
      answer:
        "No, it is not possible to take an outpatient medical insurance plan on its own. All medical insurance plans in Kenya required the insured to take a mandatory in-patient medical option.",
    },
    {
      icon: "hdr_weak",
      question:
        "What happens if I or family member has pre-existing medical conditions?",
      answer:
        "You may still be accepted on cover with the pre-existing conditions. However, pay attention to the waiting periods section of your medical insurance quoation as these will apply. Any and all pre-existing and chronic should be fully disclosed before taking up the health insurance policy, failure to do so may result in cover cancellation.",
    },
  ],
  information: {
    listInformation: [
      {
        icon: "filter_1",
        title: "Compare medical insurance.",
        description:
          "Compare medical insurance quotes from the top insurance companies.",
      },
      {
        icon: "filter_2",
        title: "Choose shared family benefits",
        description:
          "Choose shared family benefits plans or per member benefits.",
      },
      {
        icon: "filter_3",
        title: "Try different optional benefits",
        description:
          "Try different optional benefits like outpatient, maternity cover and others.",
      },
      {
        icon: "filter_4",
        title: "Save money",
        description: "Save money on your annual medical premiums.",
      },
      {
        icon: "filter_5",
        title: "Get home medical plans",
        description:
          "Get home medical plans from as low as KSh 25,000 annual premium.",
      },
    ],
    cardInformation: {
      image:
        "https://images.unsplash.com/photo-1544717302-de2939b7ef71?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80",
      title: "COMPARE HOME HEALTH INSURANCE PLANS ONLINE",
      description:
        "Find the best home medical insurance quote for your requirements. Choose shared or per individual medical plans and find flexible limits for the optional benefits like outpatient, maternity dental, optical treatments among others. Compare high end and economy plans that give access to a wide range of medical providers and hospitals in Kenya and overseas.",
      actionRoute: "pages/company/about-us",
      actionLabel: "Compare Plans",
    },
  },
};

const personalAccidentInsuranceData = {
  faqs: [
    {
      icon: "hdr_strong",
      question: "How do I get covered for maternity?",
      answer:
        "All medical insurance companies in Kenya cover maternity subject to a waiting period of 10-12 months. So, it is not possible to get a maternity insurance a pregrancy has started. Some health insurance plans in Kenya cover maternity as part of the InPatient limits while most of the plans offer maternity cover as an optional benefit at an additional cost.",
    },
    {
      icon: "hdr_weak",
      question: "Can I cover my child separately?",
      answer:
        "It is possible to cover juniors less than 18 years old on a medical insurance plan without requiring an adult to be insured on the same plan. However, only plans for inpatient medical insurance are available for juniors.",
    },
    {
      icon: "hdr_strong",
      question: "What about optical and dental covers?",
      answer:
        "Optical and Dental are mainly offered as optional benefits on most of the health insurance options. They offer valuable insurance against common eye and tooth conditions that may cause unplanned physical and financial stress. These two options may only be taken with an inpatient and outpatient plan.",
    },
    {
      icon: "hdr_weak",
      question: "Will this insurance work with my NHIF?",
      answer:
        "Yes, health insurance will work with the NHIF cover. Medical bills incurred in hospital especially for inpatient visits may be paid net of NHIF limits. This means your medical insurance limits will take you further courtesy of the NHIF benefits.",
    },
    {
      icon: "hdr_strong",
      question: "Can I take an outpatient plan only?",
      answer:
        "No, it is not possible to take an outpatient medical insurance plan on its own. All medical insurance plans in Kenya required the insured to take a mandatory in-patient medical option.",
    },
    {
      icon: "hdr_weak",
      question:
        "What happens if I or family member has pre-existing medical conditions?",
      answer:
        "You may still be accepted on cover with the pre-existing conditions. However, pay attention to the waiting periods section of your medical insurance quoation as these will apply. Any and all pre-existing and chronic should be fully disclosed before taking up the health insurance policy, failure to do so may result in cover cancellation.",
    },
  ],
  information: {
    listInformation: [
      {
        icon: "filter_1",
        title: "Compare medical insurance.",
        description:
          "Compare medical insurance quotes from the top insurance companies.",
      },
      {
        icon: "filter_2",
        title: "Choose shared family benefits",
        description:
          "Choose shared family benefits plans or per member benefits.",
      },
      {
        icon: "filter_3",
        title: "Try different optional benefits",
        description:
          "Try different optional benefits like outpatient, maternity cover and others.",
      },
      {
        icon: "filter_4",
        title: "Save money",
        description: "Save money on your annual medical premiums.",
      },
      {
        icon: "filter_5",
        title: "Get family medical plans",
        description:
          "Get family medical plans from as low as KSh 25,000 annual premium.",
      },
    ],
    cardInformation: {
      image:
        "https://images.unsplash.com/photo-1544717302-de2939b7ef71?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80",
      title: "COMPARE PERSONAL ACCIDENT INSURANCE PLANS ONLINE",
      description:
        "Find the best family medical insurance quote for your requirements. Choose shared or per individual medical plans and find flexible limits for the optional benefits like outpatient, maternity dental, optical treatments among others. Compare high end and economy plans that give access to a wide range of medical providers and hospitals in Kenya and overseas.",
      actionRoute: "pages/company/about-us",
      actionLabel: "Compare Plans",
    },
  },
};

const professionalIndemnityInsuranceData = {
  faqs: [
    {
      icon: "hdr_strong",
      question: "How do I get covered for maternity?",
      answer:
        "All medical insurance companies in Kenya cover maternity subject to a waiting period of 10-12 months. So, it is not possible to get a maternity insurance a pregrancy has started. Some health insurance plans in Kenya cover maternity as part of the InPatient limits while most of the plans offer maternity cover as an optional benefit at an additional cost.",
    },
    {
      icon: "hdr_weak",
      question: "Can I cover my child separately?",
      answer:
        "It is possible to cover juniors less than 18 years old on a medical insurance plan without requiring an adult to be insured on the same plan. However, only plans for inpatient medical insurance are available for juniors.",
    },
    {
      icon: "hdr_strong",
      question: "What about optical and dental covers?",
      answer:
        "Optical and Dental are mainly offered as optional benefits on most of the health insurance options. They offer valuable insurance against common eye and tooth conditions that may cause unplanned physical and financial stress. These two options may only be taken with an inpatient and outpatient plan.",
    },
    {
      icon: "hdr_weak",
      question: "Will this insurance work with my NHIF?",
      answer:
        "Yes, health insurance will work with the NHIF cover. Medical bills incurred in hospital especially for inpatient visits may be paid net of NHIF limits. This means your medical insurance limits will take you further courtesy of the NHIF benefits.",
    },
    {
      icon: "hdr_strong",
      question: "Can I take an outpatient plan only?",
      answer:
        "No, it is not possible to take an outpatient medical insurance plan on its own. All medical insurance plans in Kenya required the insured to take a mandatory in-patient medical option.",
    },
    {
      icon: "hdr_weak",
      question:
        "What happens if I or family member has pre-existing medical conditions?",
      answer:
        "You may still be accepted on cover with the pre-existing conditions. However, pay attention to the waiting periods section of your medical insurance quoation as these will apply. Any and all pre-existing and chronic should be fully disclosed before taking up the health insurance policy, failure to do so may result in cover cancellation.",
    },
  ],
  information: {
    listInformation: [
      {
        icon: "filter_1",
        title: "Compare medical insurance.",
        description:
          "Compare medical insurance quotes from the top insurance companies.",
      },
      {
        icon: "filter_2",
        title: "Choose shared family benefits",
        description:
          "Choose shared family benefits plans or per member benefits.",
      },
      {
        icon: "filter_3",
        title: "Try different optional benefits",
        description:
          "Try different optional benefits like outpatient, maternity cover and others.",
      },
      {
        icon: "filter_4",
        title: "Save money",
        description: "Save money on your annual medical premiums.",
      },
      {
        icon: "filter_5",
        title: "Get family medical plans",
        description:
          "Get family medical plans from as low as KSh 25,000 annual premium.",
      },
    ],
    cardInformation: {
      image:
        "https://images.unsplash.com/photo-1544717302-de2939b7ef71?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80",
      title: "COMPARE PROFESSIONAL INDEMNITY INSURANCE PLANS ONLINE",
      description:
        "Find the best family medical insurance quote for your requirements. Choose shared or per individual medical plans and find flexible limits for the optional benefits like outpatient, maternity dental, optical treatments among others. Compare high end and economy plans that give access to a wide range of medical providers and hospitals in Kenya and overseas.",
      actionRoute: "pages/company/about-us",
      actionLabel: "Compare Plans",
    },
  },
};

const fireAndBurglaryData = {
  faqs: [
    {
      icon: "hdr_strong",
      question: "How do I get covered for maternity?",
      answer:
        "All medical insurance companies in Kenya cover maternity subject to a waiting period of 10-12 months. So, it is not possible to get a maternity insurance a pregrancy has started. Some health insurance plans in Kenya cover maternity as part of the InPatient limits while most of the plans offer maternity cover as an optional benefit at an additional cost.",
    },
    {
      icon: "hdr_weak",
      question: "Can I cover my child separately?",
      answer:
        "It is possible to cover juniors less than 18 years old on a medical insurance plan without requiring an adult to be insured on the same plan. However, only plans for inpatient medical insurance are available for juniors.",
    },
    {
      icon: "hdr_strong",
      question: "What about optical and dental covers?",
      answer:
        "Optical and Dental are mainly offered as optional benefits on most of the health insurance options. They offer valuable insurance against common eye and tooth conditions that may cause unplanned physical and financial stress. These two options may only be taken with an inpatient and outpatient plan.",
    },
    {
      icon: "hdr_weak",
      question: "Will this insurance work with my NHIF?",
      answer:
        "Yes, health insurance will work with the NHIF cover. Medical bills incurred in hospital especially for inpatient visits may be paid net of NHIF limits. This means your medical insurance limits will take you further courtesy of the NHIF benefits.",
    },
    {
      icon: "hdr_strong",
      question: "Can I take an outpatient plan only?",
      answer:
        "No, it is not possible to take an outpatient medical insurance plan on its own. All medical insurance plans in Kenya required the insured to take a mandatory in-patient medical option.",
    },
    {
      icon: "hdr_weak",
      question:
        "What happens if I or family member has pre-existing medical conditions?",
      answer:
        "You may still be accepted on cover with the pre-existing conditions. However, pay attention to the waiting periods section of your medical insurance quoation as these will apply. Any and all pre-existing and chronic should be fully disclosed before taking up the health insurance policy, failure to do so may result in cover cancellation.",
    },
  ],
  information: {
    listInformation: [
      {
        icon: "filter_1",
        title: "Compare medical insurance.",
        description:
          "Compare medical insurance quotes from the top insurance companies.",
      },
      {
        icon: "filter_2",
        title: "Choose shared family benefits",
        description:
          "Choose shared family benefits plans or per member benefits.",
      },
      {
        icon: "filter_3",
        title: "Try different optional benefits",
        description:
          "Try different optional benefits like outpatient, maternity cover and others.",
      },
      {
        icon: "filter_4",
        title: "Save money",
        description: "Save money on your annual medical premiums.",
      },
      {
        icon: "filter_5",
        title: "Get family medical plans",
        description:
          "Get family medical plans from as low as KSh 25,000 annual premium.",
      },
    ],
    cardInformation: {
      image:
        "https://images.unsplash.com/photo-1544717302-de2939b7ef71?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80",
      title: "COMPARE FIRE AND BURGLARY INSURANCE PLANS ONLINE",
      description:
        "Find the best family medical insurance quote for your requirements. Choose shared or per individual medical plans and find flexible limits for the optional benefits like outpatient, maternity dental, optical treatments among others. Compare high end and economy plans that give access to a wide range of medical providers and hospitals in Kenya and overseas.",
      actionRoute: "pages/company/about-us",
      actionLabel: "Compare Plans",
    },
  },
};

const lastExpenseData = {
  faqs: [
    {
      icon: "hdr_strong",
      question: "How do I get covered for maternity?",
      answer:
        "All medical insurance companies in Kenya cover maternity subject to a waiting period of 10-12 months. So, it is not possible to get a maternity insurance a pregrancy has started. Some health insurance plans in Kenya cover maternity as part of the InPatient limits while most of the plans offer maternity cover as an optional benefit at an additional cost.",
    },
    {
      icon: "hdr_weak",
      question: "Can I cover my child separately?",
      answer:
        "It is possible to cover juniors less than 18 years old on a medical insurance plan without requiring an adult to be insured on the same plan. However, only plans for inpatient medical insurance are available for juniors.",
    },
    {
      icon: "hdr_strong",
      question: "What about optical and dental covers?",
      answer:
        "Optical and Dental are mainly offered as optional benefits on most of the health insurance options. They offer valuable insurance against common eye and tooth conditions that may cause unplanned physical and financial stress. These two options may only be taken with an inpatient and outpatient plan.",
    },
    {
      icon: "hdr_weak",
      question: "Will this insurance work with my NHIF?",
      answer:
        "Yes, health insurance will work with the NHIF cover. Medical bills incurred in hospital especially for inpatient visits may be paid net of NHIF limits. This means your medical insurance limits will take you further courtesy of the NHIF benefits.",
    },
    {
      icon: "hdr_strong",
      question: "Can I take an outpatient plan only?",
      answer:
        "No, it is not possible to take an outpatient medical insurance plan on its own. All medical insurance plans in Kenya required the insured to take a mandatory in-patient medical option.",
    },
    {
      icon: "hdr_weak",
      question:
        "What happens if I or family member has pre-existing medical conditions?",
      answer:
        "You may still be accepted on cover with the pre-existing conditions. However, pay attention to the waiting periods section of your medical insurance quoation as these will apply. Any and all pre-existing and chronic should be fully disclosed before taking up the health insurance policy, failure to do so may result in cover cancellation.",
    },
  ],
  information: {
    listInformation: [
      {
        icon: "filter_1",
        title: "Compare medical insurance.",
        description:
          "Compare medical insurance quotes from the top insurance companies.",
      },
      {
        icon: "filter_2",
        title: "Choose shared family benefits",
        description:
          "Choose shared family benefits plans or per member benefits.",
      },
      {
        icon: "filter_3",
        title: "Try different optional benefits",
        description:
          "Try different optional benefits like outpatient, maternity cover and others.",
      },
      {
        icon: "filter_4",
        title: "Save money",
        description: "Save money on your annual medical premiums.",
      },
      {
        icon: "filter_5",
        title: "Get family medical plans",
        description:
          "Get family medical plans from as low as KSh 25,000 annual premium.",
      },
    ],
    cardInformation: {
      image:
        "https://images.unsplash.com/photo-1544717302-de2939b7ef71?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80",
      title: "COMPARE LAST EXPENSE INSURANCE PLANS ONLINE",
      description:
        "Find the best family medical insurance quote for your requirements. Choose shared or per individual medical plans and find flexible limits for the optional benefits like outpatient, maternity dental, optical treatments among others. Compare high end and economy plans that give access to a wide range of medical providers and hospitals in Kenya and overseas.",
      actionRoute: "pages/company/about-us",
      actionLabel: "Compare Plans",
    },
  },
};

const insurancePremiumFinancingData = {
  faqs: [
    {
      icon: "hdr_strong",
      question: "How do I get covered for maternity?",
      answer:
        "All medical insurance companies in Kenya cover maternity subject to a waiting period of 10-12 months. So, it is not possible to get a maternity insurance a pregrancy has started. Some health insurance plans in Kenya cover maternity as part of the InPatient limits while most of the plans offer maternity cover as an optional benefit at an additional cost.",
    },
    {
      icon: "hdr_weak",
      question: "Can I cover my child separately?",
      answer:
        "It is possible to cover juniors less than 18 years old on a medical insurance plan without requiring an adult to be insured on the same plan. However, only plans for inpatient medical insurance are available for juniors.",
    },
    {
      icon: "hdr_strong",
      question: "What about optical and dental covers?",
      answer:
        "Optical and Dental are mainly offered as optional benefits on most of the health insurance options. They offer valuable insurance against common eye and tooth conditions that may cause unplanned physical and financial stress. These two options may only be taken with an inpatient and outpatient plan.",
    },
    {
      icon: "hdr_weak",
      question: "Will this insurance work with my NHIF?",
      answer:
        "Yes, health insurance will work with the NHIF cover. Medical bills incurred in hospital especially for inpatient visits may be paid net of NHIF limits. This means your medical insurance limits will take you further courtesy of the NHIF benefits.",
    },
    {
      icon: "hdr_strong",
      question: "Can I take an outpatient plan only?",
      answer:
        "No, it is not possible to take an outpatient medical insurance plan on its own. All medical insurance plans in Kenya required the insured to take a mandatory in-patient medical option.",
    },
    {
      icon: "hdr_weak",
      question:
        "What happens if I or family member has pre-existing medical conditions?",
      answer:
        "You may still be accepted on cover with the pre-existing conditions. However, pay attention to the waiting periods section of your medical insurance quoation as these will apply. Any and all pre-existing and chronic should be fully disclosed before taking up the health insurance policy, failure to do so may result in cover cancellation.",
    },
  ],
  information: {
    listInformation: [
      {
        icon: "filter_1",
        title: "Compare medical insurance.",
        description:
          "Compare medical insurance quotes from the top insurance companies.",
      },
      {
        icon: "filter_2",
        title: "Choose shared family benefits",
        description:
          "Choose shared family benefits plans or per member benefits.",
      },
      {
        icon: "filter_3",
        title: "Try different optional benefits",
        description:
          "Try different optional benefits like outpatient, maternity cover and others.",
      },
      {
        icon: "filter_4",
        title: "Save money",
        description: "Save money on your annual medical premiums.",
      },
      {
        icon: "filter_5",
        title: "Get family medical plans",
        description:
          "Get family medical plans from as low as KSh 25,000 annual premium.",
      },
    ],
    cardInformation: {
      image:
        "https://images.unsplash.com/photo-1544717302-de2939b7ef71?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80",
      title: "COMPARE INSURANCE PREMIUM FINANCING PLANS ONLINE",
      description:
        "Find the best family medical insurance quote for your requirements. Choose shared or per individual medical plans and find flexible limits for the optional benefits like outpatient, maternity dental, optical treatments among others. Compare high end and economy plans that give access to a wide range of medical providers and hospitals in Kenya and overseas.",
      actionRoute: "pages/company/about-us",
      actionLabel: "Compare Plans",
    },
  },
};

// Typechecking props for the seniorHealthData
homeInsuranceData.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
};
homeInsuranceData.information.listInformation.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
};
homeInsuranceData.information.cardInformation.propTypes = {
  faqs: PropTypes.object,
};

personalAccidentInsuranceData.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
};
personalAccidentInsuranceData.information.listInformation.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
};
personalAccidentInsuranceData.information.cardInformation.propTypes = {
  faqs: PropTypes.object,
};

professionalIndemnityInsuranceData.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
};
professionalIndemnityInsuranceData.information.listInformation.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
};
professionalIndemnityInsuranceData.information.cardInformation.propTypes = {
  faqs: PropTypes.object,
};

fireAndBurglaryData.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
};
fireAndBurglaryData.information.listInformation.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
};
fireAndBurglaryData.information.cardInformation.propTypes = {
  faqs: PropTypes.object,
};

lastExpenseData.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
};
lastExpenseData.information.listInformation.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
};
lastExpenseData.information.cardInformation.propTypes = {
  faqs: PropTypes.object,
};

insurancePremiumFinancingData.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
};
insurancePremiumFinancingData.information.listInformation.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
};
insurancePremiumFinancingData.information.cardInformation.propTypes = {
  faqs: PropTypes.object,
};

export {
  homeInsuranceData,
  personalAccidentInsuranceData,
  professionalIndemnityInsuranceData,
  fireAndBurglaryData,
  lastExpenseData,
  insurancePremiumFinancingData,
};
